<div style="height: 36px">
    @if (documentResource.isLoading() || logoResource.isLoading()) {
        <!--show nothing-->
    } @else if (url()) {
        <img
            alt="Logo"
            [src]="url()"
            style="max-height: 24px"
        />
    } @else if (company()?.logo) {
        <img
            alt="Logo"
            src="{{ 'data:image/' + (fileSuffix() ? fileSuffix() : 'jpeg') + ';base64, ' + company()?.logo }}"
            style="max-height: 24px"
        />
    } @else if (logo()) {
        <img [src]="logo()" alt="Logo" style="max-height: 24px" />
    } @else {
        <p>{{ company()?.name }}</p>
    }
</div>
